import api from '../index'
import {
  IProject,
  IVOProjectBulk,
  IVOProjectArchive,
  IVOProjectsProcedure,
  IVOProjectConclude,
  IGetProjects
} from '@domain/project'

export const getProject = (id: string): Promise<Array<IProject>> =>
  api.get(`/projects/${id}`).then((res) => res.data)

export const getProjects = (data?: IGetProjects) => {
  return api.get('/projects', {
    params: { ...data }
  })
}

export const postProject = (data: IProject) => {
  return api.post('/projects', data)
}

export const postBulkProject = (data: IVOProjectBulk) => {
  return api.post('/projects/bulk', data)
}

export const patchBulkProject = (data: IVOProjectConclude) => {
  return api.patch('/projects/bulk', data)
}

export const patchRecoverProject = (data: { ids: string[] }) => {
  return api.patch('/projects/recover', data)
}

export const putProject = (data: IProject) => {
  return api.put('/projects', data)
}

export const patchProjectsProcedure = (data: IVOProjectsProcedure) => {
  return api.patch('/projects/procedures', data)
}

export const archiveProject = (data: IVOProjectArchive) => {
  return api.delete('/projects', { data })
}

export const activateProject = (data: IVOProjectArchive) => {
  return api.patch('/projects/recover', data)
}

export const startProject = (projectId: string) => {
  return api.put(`/projects/${projectId}/start`)
}
